import { render, staticRenderFns } from "./tiposdeconvenios.vue?vue&type=template&id=2c641929"
import script from "./tiposdeconvenios.vue?vue&type=script&lang=js"
export * from "./tiposdeconvenios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports